import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function logInteraction(componentName: string, actionName: string, data?: any) {
  console.log(`[Interaction] ${componentName} -> ${actionName}`, data || '');
}
